// extracted by mini-css-extract-plugin
module.exports = {"ProductsGrid":"styles_ProductsGrid__9TLff","left":"styles_left__eo2ey","right":"styles_right__UInMJ","item":"styles_item__egF63"};